import { render, staticRenderFns } from "./send.vue?vue&type=template&id=63f3e248&scoped=true&"
import script from "./send.vue?vue&type=script&lang=js&"
export * from "./send.vue?vue&type=script&lang=js&"
import style0 from "./send.vue?vue&type=style&index=0&id=63f3e248&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f3e248",
  null
  
)

export default component.exports